import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import app from '../firebase';

const functions = getFunctions(app, 'us-central1');

// État global du loading Stripe
let _setStripeLoading = null;
export function registerStripeLoading(setter) {
  _setStripeLoading = setter;
}

function showLoading() {
  if (_setStripeLoading) _setStripeLoading(true);
}

function hideLoading() {
  if (_setStripeLoading) _setStripeLoading(false);
}

export async function buyPlumes(packId) {
  showLoading();
  try {
    const createCheckout = httpsCallable(functions, 'createPlumesCheckout');
    const result = await createCheckout({ packId });
    window.location.href = result.data.url;
  } catch (e) {
    hideLoading();
    throw e;
  }
}

export async function subscribePremium(plan) {
  showLoading();
  try {
    const createCheckout = httpsCallable(functions, 'createPremiumCheckout');
    const result = await createCheckout({ plan });
    window.location.href = result.data.url;
  } catch (e) {
    hideLoading();
    throw e;
  }
}

export async function supportAuthor(amount, authorId, authorName) {
  showLoading();
  try {
    const createCheckout = httpsCallable(functions, 'createSupportCheckout');
    const result = await createCheckout({ amount, authorId, authorName });
    window.location.href = result.data.url;
  } catch (e) {
    hideLoading();
    throw e;
  }
}

export async function cancelPremium() {
  const auth = getAuth();
  const token = await auth.currentUser.getIdToken();

  const response = await fetch('https://us-central1-plumly-fe6f7.cloudfunctions.net/cancelPremium', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
    },
  });

  if (!response.ok) {
    throw new Error('Erreur annulation');
  }

  return await response.json();
}

export async function createConnectAccount() {
  showLoading();
  try {
    const auth = getAuth();
    const token = await auth.currentUser.getIdToken();
    const response = await fetch('https://us-central1-plumly-fe6f7.cloudfunctions.net/createConnectAccount', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
    });
    if (!response.ok) throw new Error('Erreur création compte');
    const data = await response.json();
    window.location.href = data.url;
  } catch (e) {
    hideLoading();
    throw e;
  }
}

export async function getConnectStatus() {
  const auth = getAuth();
  const token = await auth.currentUser.getIdToken();
  const response = await fetch('https://us-central1-plumly-fe6f7.cloudfunctions.net/getConnectStatus', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
  });
  if (!response.ok) throw new Error('Erreur statut');
  return await response.json();
}

export async function requestPayout() {
  const auth = getAuth();
  const token = await auth.currentUser.getIdToken();
  const response = await fetch('https://us-central1-plumly-fe6f7.cloudfunctions.net/requestPayout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Erreur versement');
  }
  return await response.json();
}

export async function deleteAccount() {
  const auth = getAuth();
  const token = await auth.currentUser.getIdToken();
  const response = await fetch('https://us-central1-plumly-fe6f7.cloudfunctions.net/deleteAccount', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Erreur suppression');
  }
  return await response.json();
}